/**
 * Verona Tempo — product page features (round 9 T3). Vanilla JS, no dependencies.
 * Loaded (deferred) ONLY on product templates, right after assets/vt-theme.js (layout/theme.liquid), so it runs
 * after all the global features and uses their shared helpers from window.vtCore (see the top of vt-theme.js).
 * Nothing here is needed in the quick view on collection / home / search pages (those parts stay in
 * vt-theme.js: "Only X left" badges, "Save $X", points, stock line, colour caption, size guide, add-to-bag messages).
 *  - Recently viewed: remembers this product (the rows themselves are drawn by vt-theme.js on every page)
 *  - Product gallery counter "2 / 5" (phones / tablets)
 *  - "Free delivery on this order" hint under the buttons (U8)
 *  - Size memory: picks her remembered size and shows "Your size 38 · Change" (U1)
 *  - "Watch it worn" video chip + dialog (YouTube / MP4 / Instagram / TikTok, loads only on tap)
 *  - "Shop similar" when the chosen variant is sold out (E6)
 *  - Sticky add-to-bag bar says "Colour: Black · Size: 38" (D4)
 *  - "Similar price" row (store search, loaded when it comes near) (U9)
 *  - Round 9: previous / next product in the order she saw on the listing (U3), "Tap to zoom" hint once (U4),
 *    "sold out" read out on size / colour buttons for screen readers (T5)
 *  - Round 11: soft cross-fade between the big photos (D8), new sticky bar with photo / price / "Black · 38" (U1),
 *    only the next photo fetched ahead (T2), "Your size" tag from the size guide (U5)
 * Config + translated strings: window.vtConfig (snippets/vt-config.liquid) — the same object as vtCore.cfg.
 */
(function () {
  'use strict';

  var core = window.vtCore;
  if (!core) return; // vt-theme.js did not run

  var cfg = core.cfg;
  var S = core.S;
  var RECENT_KEY = core.keys.recent;
  var RECENT_MAX = core.keys.recentMax;
  var route = core.route;
  var tpl = core.tpl;
  var esc = core.esc;
  var shortMoney = core.shortMoney;
  var readList = core.readList;
  var writeList = core.writeList;
  var readSizeMemory = core.readSizeMemory;
  var writeSizeMemory = core.writeSizeMemory;
  var isSizeOption = core.isSizeOption;
  var parseJsonEl = core.parseJsonEl;
  var loadScriptOnce = core.loadScriptOnce;
  var onCart = core.onCart;
  var refreshCart = core.refreshCart;
  var announce = core.announce;

  /* -------------------------------------------------------- recently viewed */
  function recordRecentlyViewed() {
    if (!cfg.recentlyViewed || !cfg.productHandle) return;
    var list = readList(RECENT_KEY).filter(function (h) { return h !== cfg.productHandle; });
    list.unshift(cfg.productHandle);
    writeList(RECENT_KEY, list.slice(0, RECENT_MAX));
  }

  /* ----------------------------------------- product gallery counter (r4) */
  function initGalleryCounter() {
    document.querySelectorAll('.template-product media-gallery .main-image').forEach(function (main) {
      if (main.querySelector('.vt-gallery-count')) return;
      if (main.querySelectorAll('carousel-slider .slider__item').length < 2) return;
      var counter = document.createElement('span');
      counter.className = 'vt-gallery-count';
      counter.setAttribute('aria-hidden', 'true');
      main.appendChild(counter);
      /* r10: bigger, clearer position dots under the photo on phones (up to 8 photos; the "2 / 5" counter stays for more) */
      var dots = null;
      if (document.documentElement.classList.contains('vt-r10-dots')) {
        dots = document.createElement('div');
        dots.className = 'vt-gallery-dots';
        dots.setAttribute('aria-hidden', 'true');
        main.appendChild(dots);
      }
      var set = function () {
        var visible = Array.prototype.filter.call(main.querySelectorAll('carousel-slider .slider__item'), function (el) { return !el.hidden; });
        var index = 0;
        visible.forEach(function (el, i) { if (el.classList.contains('is-active')) index = i; });
        counter.textContent = (index + 1) + ' / ' + visible.length;
        if (dots) {
          var use = visible.length > 1 && visible.length <= 8;
          main.classList.toggle('vt-has-dots', use);
          if (dots.childElementCount !== visible.length) {
            dots.innerHTML = '';
            for (var d = 0; d < visible.length; d++) dots.appendChild(document.createElement('span'));
          }
          Array.prototype.forEach.call(dots.children, function (dot, i) { dot.classList.toggle('is-active', i === index); });
        }
      };
      set();
      var scope = main.closest('.js-product') || main;
      scope.addEventListener('on:carousel-slider:select', function () { window.requestAnimationFrame(set); });
      scope.addEventListener('on:variant:change', function () { window.setTimeout(set, 60); });
    });
  }

  /* ---- U8: "Free delivery on this order" on the product page ------------- */
  function initDeliveryHint() {
    var hint = document.querySelector('[data-vt-fd-hint]');
    if (!hint) return;
    var threshold = parseInt(hint.dataset.threshold, 10) || 0;
    var price = parseInt(hint.dataset.price, 10) || 0;
    var variantId = parseInt(hint.dataset.variant, 10) || 0;
    var text = hint.querySelector('[data-vt-fd-hint-text]');
    var cart = null;
    var render = function () {
      if (!cart || !threshold || !text) return;
      var inCart = cart.items.some(function (i) { return i.variant_id === variantId; });
      var total = cart.total_price + (inCart ? 0 : price);
      var free = total >= threshold;
      var msg = free ? S.fdHintFree : tpl(S.fdHintAdd, { amount: shortMoney(threshold - total) });
      if (text.textContent !== msg) text.textContent = msg;
      hint.classList.toggle('is-free', free);
      hint.hidden = false;
    };
    var scope = hint.closest('.js-product') || document;
    scope.addEventListener('on:variant:change', function (evt) {
      var v = evt.detail && evt.detail.variant;
      if (v) { price = v.price; variantId = v.id; }
      render();
    });
    onCart(function (c) { cart = c; render(); });
    refreshCart();
  }

  function initSizeMemory() {
    if (!cfg.sizeMemory || !cfg.sizeCategory || !document.body.classList.contains('template-product')) return;
    var picker = document.querySelector('#content .js-product variant-picker');
    if (!picker) return;
    var selectors = Array.prototype.slice.call(picker.querySelectorAll('.option-selector'));
    var sizeIndex = -1;
    selectors.forEach(function (sel, i) { if (sizeIndex === -1 && isSizeOption(sel.dataset.option)) sizeIndex = i; });
    if (sizeIndex === -1) return;
    var fieldset = selectors[sizeIndex];
    if (!fieldset.querySelector('input[type="radio"]')) return;
    var category = cfg.sizeCategory;
    var note = null;

    var removeNote = function () { if (note) { note.remove(); note = null; } };
    var showNote = function (size) {
      removeNote();
      note = document.createElement('p');
      note.className = 'vt-size-note';
      note.innerHTML = '<span>' + esc(tpl(S.sizeMemory, { size: size })) + '</span> <span aria-hidden="true">·</span> <button type="button" class="vt-size-note__change">' + esc(S.sizeMemoryChange) + '</button>';
      var anchor = fieldset.querySelector('.option-selector__btns') || fieldset.lastElementChild;
      anchor.insertAdjacentElement('afterend', note);
      note.querySelector('button').addEventListener('click', function () {
        writeSizeMemory(category, '');
        removeNote();
        announce(S.sizeMemoryForgotten);
        var first = fieldset.querySelector('input[type="radio"]:checked') || fieldset.querySelector('input[type="radio"]');
        if (first) first.focus();
      });
    };

    fieldset.addEventListener('change', function (evt) {
      var input = evt.target;
      if (!evt.isTrusted || !input || input.type !== 'radio') return;
      writeSizeMemory(category, input.value);
      showNote(input.value);
    });

    var remembered = readSizeMemory()[category];
    if (!remembered) return;
    var input = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]')).filter(function (i) { return i.value === remembered; })[0];
    if (!input) return;
    var params = new URLSearchParams(window.location.search);
    var apply = function () {
      if (input.checked) { showNote(remembered); return; }
      if (params.has('variant')) return; // a shared link to a specific variant wins
      var data = parseJsonEl(picker.querySelector('script[type="application/json"]'), { variants: [] });
      var selected = selectors.map(function (sel) {
        var c = sel.querySelector('input:checked');
        return c ? c.value : null;
      });
      var ok = (data.variants || []).some(function (v) {
        if (!v.available || v.options[sizeIndex] !== remembered) return false;
        for (var j = 0; j < selected.length; j += 1) {
          if (j !== sizeIndex && selected[j] !== null && v.options[j] !== selected[j]) return false;
        }
        return true;
      });
      if (!ok) return; // sold out in this colour: leave the choice to her
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      showNote(remembered);
    };
    // wait until the picker and the gallery sliders are initialised (Symmetry sets them up lazily),
    // otherwise the gallery cannot move to the matching photo yet
    var scope = picker.closest('.js-product') || document;
    var tries = 0;
    var whenReady = function () {
      var sliders = scope.querySelectorAll('carousel-slider');
      var ready = Array.prototype.every.call(sliders, function (sl) {
        return sl.slider || sl.offsetParent === null || !sl.slides || sl.slides.length < 2;
      });
      if (ready || tries > 25) apply(); else { tries += 1; window.setTimeout(whenReady, 120); }
    };
    var start = function () {
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('variant-picker').then(function () { window.setTimeout(whenReady, 50); });
      } else {
        whenReady();
      }
    };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
  }

  /* ---- D5 + E5: "Watch it worn" video (loads only on tap) ---------------- */
  var videoDialog = null;

  function videoLink(url) {
    var link = document.createElement('a');
    link.className = 'btn btn--secondary';
    link.href = /^https:\/\//.test(url) ? url : '#';
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = S.videoOpen;
    return link;
  }
  function videoEmbed(kind, url) {
    var box = document.createElement('div');
    box.className = 'vt-video__frame vt-video__frame--' + kind;
    var m;
    if (kind === 'youtube' && (m = url.match(/(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,20})/))) {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0&playsinline=1';
      iframe.title = S.videoTitle;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.setAttribute('allowfullscreen', '');
      box.appendChild(iframe);
      return box;
    }
    if (kind === 'mp4' && /^https:\/\/[^\s"'<>]+\.mp4(\?[^\s"'<>]*)?$/i.test(url)) {
      var video = document.createElement('video');
      video.src = url;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      box.appendChild(video);
      return box;
    }
    if (kind === 'instagram' && (m = url.match(/^https:\/\/(?:www\.)?instagram\.com\/(?:[A-Za-z0-9_.]+\/)?(reel|reels|p|tv)\/([A-Za-z0-9_-]+)/))) {
      var permalink = 'https://www.instagram.com/' + (m[1] === 'reels' ? 'reel' : m[1]) + '/' + m[2] + '/';
      var bq = document.createElement('blockquote');
      bq.className = 'instagram-media';
      bq.setAttribute('data-instgrm-permalink', permalink);
      bq.setAttribute('data-instgrm-version', '14');
      bq.appendChild(videoLink(permalink));
      box.appendChild(bq);
      loadScriptOnce('https://www.instagram.com/embed.js').then(function () {
        if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
      });
      return box;
    }
    if (kind === 'tiktok' && (m = url.match(/^https:\/\/(?:www\.)?tiktok\.com\/@([A-Za-z0-9_.-]+)\/video\/(\d+)/))) {
      var cite = 'https://www.tiktok.com/@' + m[1] + '/video/' + m[2];
      var tq = document.createElement('blockquote');
      tq.className = 'tiktok-embed';
      tq.setAttribute('cite', cite);
      tq.setAttribute('data-video-id', m[2]);
      var sec = document.createElement('section');
      sec.appendChild(videoLink(cite));
      tq.appendChild(sec);
      box.appendChild(tq);
      loadScriptOnce('https://www.tiktok.com/embed.js', true); // TikTok scans the page each time its script runs
      return box;
    }
    // short links or other hosts: a plain link that opens in a new tab
    box.appendChild(videoLink(url));
    return box;
  }
  if (!customElements.get('vt-video-chip')) {
    customElements.define('vt-video-chip', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        var btn = this.querySelector('button');
        if (btn) btn.addEventListener('click', (evt) => { evt.preventDefault(); evt.stopPropagation(); this.open(btn); });
      }

      open(opener) {
        if (!videoDialog) {
          videoDialog = document.createElement('dialog');
          videoDialog.className = 'vt-video';
          videoDialog.setAttribute('aria-labelledby', 'vt-video-title');
          videoDialog.innerHTML =
            '<div class="vt-video__head"><h2 class="vt-video__title" id="vt-video-title"></h2>' +
            '<button type="button" class="vt-video__close" data-vt-video-close aria-label="' + esc(S.close) + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
            '<div class="vt-video__body" data-vt-video-body></div>';
          document.body.appendChild(videoDialog);
          videoDialog.addEventListener('click', function (evt) {
            if (evt.target === videoDialog || evt.target.closest('[data-vt-video-close]')) videoDialog.close();
          });
          videoDialog.addEventListener('close', function () {
            if (videoDialog.open) return; // re-opened before this (async) event arrived
            videoDialog.querySelector('[data-vt-video-body]').innerHTML = ''; // stops playback
            document.documentElement.classList.remove('vt-sg-open');
            if (videoDialog.opener && videoDialog.opener.focus) videoDialog.opener.focus();
          });
        }
        videoDialog.opener = opener;
        videoDialog.querySelector('#vt-video-title').textContent = this.dataset.title || S.videoTitle;
        var body = videoDialog.querySelector('[data-vt-video-body]');
        body.innerHTML = '';
        body.appendChild(videoEmbed(this.dataset.kind, this.dataset.url || ''));
        if (typeof videoDialog.showModal === 'function') {
          videoDialog.showModal();
          document.documentElement.classList.add('vt-sg-open');
          videoDialog.querySelector('[data-vt-video-close]').focus();
        } else if (/^https:\/\//.test(this.dataset.url || '')) {
          window.open(this.dataset.url, '_blank', 'noopener');
        }
      }
    });
  }

  /* ---- E6: "Shop similar" when sold out ---------------------------------- */
  if (!customElements.get('vt-shop-similar')) {
    customElements.define('vt-shop-similar', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.list = this.querySelector('[data-vt-list]');
        if (this.dataset.soldOut === 'true') this.show();
        var scope = this.closest('.js-product') || document;
        scope.addEventListener('on:variant:change', (evt) => {
          var v = evt.detail && evt.detail.variant;
          if (!v) return;
          if (v.available) this.hidden = true; else this.show();
        });
      }

      show() {
        if (this.loaded) {
          this.hidden = !this.hasItems;
          return;
        }
        this.loaded = true;
        var url = 'recommendations/products?product_id=' + encodeURIComponent(this.dataset.productId) + '&limit=10&intent=related&section_id=vt-shop-similar';
        fetch(route(url))
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then((html) => {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var type = this.dataset.type || '';
            var items = Array.prototype.slice.call(tmp.querySelectorAll('.vt-similar__item'));
            items.sort(function (a, b) {
              return (b.dataset.type === type ? 1 : 0) - (a.dataset.type === type ? 1 : 0);
            });
            items = items.slice(0, 4);
            this.hasItems = items.length > 0;
            if (!this.hasItems || !this.list) return;
            this.list.innerHTML = '';
            items.forEach((el) => {
              var block = el.querySelector('product-block');
              if (block) this.list.appendChild(block);
            });
            this.hidden = false;
          })
          .catch(function () {});
      }
    });
  }

  /* ---- D4: sticky add-to-bag bar says "Colour: Black · Size: 38" ---------- */
  function initStickyOptions() {
    var sticky = document.querySelector('sticky-atc');
    if (!sticky) return;
    var section = sticky.closest('.section-main-product') || document;
    var form = section.querySelector('.js-product');
    // r11 (U1): new bar — white, thin line on top, photo + name + price + "Black · 38" (Theme settings > Verona Tempo)
    var r11 = !!(form && form.hasAttribute('data-vt-sticky11'));
    if (r11) sticky.classList.add('vt-sticky11');
    if (!cfg.stickyOptions && !r11) return;
    var picker = section.querySelector('.js-product variant-picker');
    var price = null;
    var titleRow = sticky.querySelector('.sticky-atc__details__title');
    if (r11 && titleRow) {
      price = document.createElement('div');
      price.className = 'vt-sticky11__price';
      titleRow.insertAdjacentElement('afterend', price);
    }
    var renderPrice = function () {
      if (!price || !form) return;
      var cur = form.querySelector('.product-info__price .price__default .price__current .js-value');
      var was = form.querySelector('.product-info__price .price__default .price__was .js-value');
      var html = cur && cur.textContent.trim() ? '<span class="vt-sticky11__now">' + esc(cur.textContent.trim()) + '</span>' : '';
      if (html && was && was.textContent.trim() && was.offsetParent !== null) html += ' <s class="vt-sticky11__was">' + esc(was.textContent.trim()) + '</s>';
      if (price.innerHTML !== html) price.innerHTML = html;
      price.hidden = !html;
    };
    var render = function () {
      renderPrice();
      if (!picker) return;
      var title = sticky.querySelector('.sticky-atc__details__variant__title');
      var box = sticky.querySelector('.sticky-atc__details__variant');
      if (!title || !box) return;
      var parts = [];
      picker.querySelectorAll('.option-selector').forEach(function (sel) {
        var name = sel.dataset.option || '';
        var checked = sel.querySelector('input[type="radio"]:checked');
        var field = sel.querySelector('select, input[type="hidden"]');
        var value = checked ? checked.value : (field && field.value ? field.value : '');
        if (r11) parts.push(value || tpl(S.stickyChoose, { option: name.toLowerCase() }));
        else parts.push(value ? name + ': ' + value : tpl(S.stickyChoose, { option: name.toLowerCase() }));
      });
      if (!parts.length) return;
      var text = parts.join(' · ');
      if (title.textContent !== text) title.textContent = text;
      title.hidden = false;
      box.hidden = false;
      sticky.classList.add('vt-sticky-options');
    };
    var later = function () { window.setTimeout(render, 0); window.setTimeout(render, 150); };
    section.addEventListener('on:variant:change', later);
    if (picker) picker.addEventListener('change', later);
    if (customElements.whenDefined) customElements.whenDefined('sticky-atc').then(later);
    later();
  }

  /* ---- r11 (D8): soft cross-fade between the big product photos ------------------------------------------
     The gallery stays Symmetry's scroll carousel, so a swipe on phones keeps following the finger. Every jump the
     scripts ask for (arrows, thumbnails, a colour change) is done instantly underneath a copy of the old photo, and
     that copy fades out (opacity, about half a second): a cross-fade. Dragging with the mouse is left alone. Instant
     change (no fade, no slide) without Theme settings > Enable animations or for people who ask for less motion.
     Switch: Theme settings > Verona Tempo > "Soft cross-fade between product photos" (media-gallery data-vt-fade). */
  function initFade() {
    var gallery = document.querySelector('.section-main-product media-gallery[data-vt-fade]');
    if (!gallery) return;
    var cs = gallery.querySelector('.main-image carousel-slider');
    var slider = cs && cs.querySelector('.slider');
    var host = cs && cs.closest('.main-image');
    if (!slider || !host || slider.vtFade) return;
    slider.vtFade = true;
    host.classList.add('vt-fade-host');
    var orig = slider.scrollTo;
    var ready = false;
    var arm = function () { window.setTimeout(function () { ready = true; }, 300); };
    if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm, { once: true });
    var canFade = function () { return document.documentElement.classList.contains('vt-anim') && !core.reducedMotion(); };
    var slides = function () { return Array.prototype.filter.call(cs.querySelectorAll('.slider__item'), function (el) { return !el.hidden; }); };
    var slideAt = function (left) {
      var list = slides();
      var span = cs.slideSpan || (list[0] && list[0].offsetWidth) || 1;
      return list[Math.max(0, Math.min(list.length - 1, Math.round(Math.abs(left) / span)))];
    };
    slider.scrollTo = function (opts) {
      if (!ready || !opts || typeof opts !== 'object' || typeof opts.left !== 'number' || cs.mousedown) return orig.apply(this, arguments);
      if (Math.abs(opts.left - this.scrollLeft) < 2) return orig.apply(this, arguments);
      var instant = { left: opts.left, behavior: 'instant' };
      if (!canFade()) return orig.call(this, instant);
      var from = slideAt(this.scrollLeft);
      var to = slideAt(opts.left);
      var img = from && from.querySelector('.product-media--image img');
      if (!img || !img.complete || !img.naturalWidth || from === to) return orig.call(this, instant);
      host.querySelectorAll('.vt-fade-ghost').forEach(function (g) { g.remove(); });
      var hr = host.getBoundingClientRect();
      var ir = img.getBoundingClientRect();
      var ghost = document.createElement('img');
      ghost.className = 'vt-fade-ghost';
      ghost.alt = '';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.src = img.currentSrc || img.src;
      ghost.style.cssText = 'left:' + (ir.left - hr.left) + 'px;top:' + (ir.top - hr.top) + 'px;width:' + ir.width + 'px;height:' + ir.height + 'px';
      host.appendChild(ghost);
      var next = to && to.querySelector('.product-media--image img');
      if (next && next.loading === 'lazy') next.loading = 'eager';
      orig.call(this, instant);
      var started = false;
      var start = function () {
        if (started) return;
        started = true;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            ghost.classList.add('is-out');
            window.setTimeout(function () { ghost.remove(); }, 900);
          });
        });
      };
      if (!next || (next.complete && next.naturalWidth)) start();
      else {
        next.addEventListener('load', start, { once: true });
        next.addEventListener('error', start, { once: true });
        window.setTimeout(start, 1200);
      }
      return undefined;
    };
  }

  /* ---- r11 (T2): with the luxury page only the photo after the one she sees is fetched ahead (quietly, after the
     page has loaded) instead of every big photo after 3 s (Symmetry's data-preload, switched off for .vt-pdp11). */
  function initNextPhoto() {
    var cs = document.querySelector('.section-main-product .vt-pdp11 media-gallery .main-image carousel-slider');
    if (!cs) return;
    var warm = function () {
      var list = Array.prototype.filter.call(cs.querySelectorAll('.slider__item'), function (el) { return !el.hidden; });
      var i = list.indexOf(cs.querySelector('.slider__item.is-active'));
      [list[i + 1], list[i - 1]].forEach(function (slide) {
        var img = slide && slide.querySelector('.product-media--image img[loading="lazy"]');
        if (img) img.loading = 'eager';
      });
    };
    var later = function () { window.setTimeout(function () { (window.requestIdleCallback || window.setTimeout)(warm); }, 1500); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    (cs.closest('.js-product') || document).addEventListener('on:carousel-slider:select', function () { window.setTimeout(warm, 50); });
  }

  /* ---- r11 (U5): "Your size" tag from the size guide ---------------------------------------------------------
     The EU size she converted in the size guide (localStorage "vt_conv_size", written by <vt-size-converter> in
     assets/vt-theme.js) gets a small "Your size" tag on that size button; it is never chosen for her. A line under
     the sizes offers "Forget my size" (hidden by CSS while the round 5 "Your size: 38 · change" note shows).
     Converting in the size guide pop-up updates the tag at once (event "vt:conv-size"). */
  var CONV_KEY = 'vt_conv_size';
  function validEu(v) { return /^\d{2}(\.5)?$/.test(String(v || '')); }
  function initYourSize() {
    var form = document.querySelector('.section-main-product .js-product[data-vt-your-size]');
    var picker = form && form.querySelector('variant-picker');
    if (!picker) return;
    var fieldset = null;
    picker.querySelectorAll('.option-selector').forEach(function (sel) { if (!fieldset && isSizeOption(sel.dataset.option)) fieldset = sel; });
    if (!fieldset || !fieldset.querySelector('input[type="radio"]')) return;
    var line = null;
    var render = function (eu) {
      fieldset.querySelectorAll('.vt-your-size').forEach(function (el) { el.remove(); });
      fieldset.querySelectorAll('.vt-is-yours').forEach(function (el) { el.classList.remove('vt-is-yours'); });
      if (line) { line.remove(); line = null; }
      if (!validEu(eu)) return;
      var input = Array.prototype.filter.call(fieldset.querySelectorAll('input[type="radio"]'), function (i) {
        return i.value === eu || i.value.replace(/^EU\s*/i, '') === eu;
      })[0];
      var label = input && input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') return;
      label.classList.add('vt-is-yours');
      label.insertAdjacentHTML('beforeend', '<span class="vt-your-size" aria-hidden="true">' + esc(form.dataset.vtYourSize) + '</span>' +
        '<span class="vt-your-size visually-hidden">, ' + esc(form.dataset.vtYourSize) + '</span>');
      line = document.createElement('p');
      line.className = 'vt-yoursize-line';
      line.innerHTML = '<span>' + esc(tpl(form.dataset.vtYourSizeNote || '', { size: eu })) + '</span> <span aria-hidden="true">·</span> ' +
        '<button type="button" class="vt-yoursize-line__forget">' + esc(form.dataset.vtForgetSize || '') + '</button>';
      var anchor = fieldset.querySelector('.option-selector__btns') || fieldset.lastElementChild;
      anchor.insertAdjacentElement('afterend', line);
      line.querySelector('button').addEventListener('click', function () {
        try { window.localStorage.removeItem(CONV_KEY); } catch (e) { /* storage blocked */ }
        render('');
        document.dispatchEvent(new CustomEvent('vt:conv-size', { detail: { eu: '' } }));
        announce(form.dataset.vtSizeForgotten || '');
        var first = fieldset.querySelector('input[type="radio"]:checked') || fieldset.querySelector('input[type="radio"]');
        if (first) first.focus();
      });
    };
    var saved = '';
    try { saved = window.localStorage.getItem(CONV_KEY) || ''; } catch (e) { saved = ''; }
    render(saved);
    document.addEventListener('vt:conv-size', function (evt) { render(evt.detail && evt.detail.eu); });
  }

  /* ---- U9: "Similar price" row (store search, loaded when it comes near) ---- */
  function initSimilarPrice() {
    if (!cfg.similarPrice) return;
    var box = document.querySelector('[data-vt-simprice]');
    if (!box) return;
    var load = function () {
      var q = 'product_type:"' + String(box.dataset.type || '').replace(/"/g, '') + '"';
      var url = route('search') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=none' +
        '&filter.v.availability=1&filter.v.price.gte=' + encodeURIComponent(box.dataset.min) +
        '&filter.v.price.lte=' + encodeURIComponent(box.dataset.max) + '&section_id=vt-similar-price';
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var grid = tmp.querySelector('[data-vt-simprice-results] .product-grid');
          if (!grid) return;
          var handle = box.dataset.handle;
          Array.prototype.slice.call(grid.children).forEach(function (card) {
            var a = card.querySelector('a[href*="/products/"]');
            var href = a ? a.getAttribute('href').split(/[?#]/)[0] : '';
            if (href && href.slice(-('/products/' + handle).length) === '/products/' + handle) card.remove();
          });
          while (grid.children.length > 4) grid.lastElementChild.remove();
          if (!grid.children.length) return;
          grid.querySelectorAll('[data-cc-animate]').forEach(function (el) { el.removeAttribute('data-cc-animate'); });
          var slot = box.querySelector('[data-vt-simprice-slot]');
          slot.innerHTML = '';
          slot.appendChild(grid);
          box.hidden = false;
          if (window.vtSyncCompare) window.vtSyncCompare();
        })
        .catch(function () { /* stays hidden */ });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      // the box itself is hidden (no size), so watch its section
      io.observe(box.closest('.shopify-section') || box.parentNode);
    } else {
      load();
    }
  }

  /* ---- r9 U3: previous / next product in the order she saw on the listing ----
     sections/main-product.liquid (snippet vt-product-nav) already links Shopify's collection order when the
     address is /collections/<c>/products/<p>. The listing pages leave what she actually saw (sort, filters,
     "Load more") in sessionStorage "vt-listing-order" = { handle, title, url, items: [{ handle, url, title }] }:
     when this product is in that list, its neighbours there are used instead; on /products/<p> the links are
     only added when she came straight from that listing (or from a product of it). */
  var LISTING_KEY = 'vt-listing-order';
  function sameOriginPath(url) {
    try {
      var u = new URL(url, window.location.href);
      return u.origin === window.location.origin ? u.pathname.replace(/\/$/, '') : '';
    } catch (e) { return ''; }
  }
  function initPdpNav() {
    var nav = document.querySelector('.section-main-product [data-vt-pdp-nav]');
    if (!nav) return;
    var data = null;
    try { data = JSON.parse(core.storageGet('sessionStorage', LISTING_KEY) || 'null'); } catch (e) { data = null; }
    if (!data || !Array.isArray(data.items) || !data.items.length) return;
    var handle = nav.dataset.handle;
    var items = data.items.filter(function (it) { return it && typeof it.handle === 'string' && it.handle; });
    var index = -1;
    items.forEach(function (it, i) { if (index === -1 && it.handle === handle) index = i; });
    if (index === -1) return;
    var coll = nav.dataset.collection;
    if (coll) {
      if (data.handle !== coll) return;
    } else {
      // opened as /products/<p>: only when she came from that listing, or from one of its products
      var ref = sameOriginPath(document.referrer);
      var listPath = sameOriginPath(data.url || '');
      var refHandle = (ref.match(/\/products\/([^/]+)$/) || [])[1];
      var fromList = ref && listPath && ref === listPath;
      var fromItem = refHandle && items.some(function (it) { return it.handle === decodeURIComponent(refHandle); });
      if (!fromList && !fromItem) return;
    }
    // At the ends of her list: nothing before the first product; after the last one Shopify's own "Next" (from
    // the page) stays only when the listing was in the collection's own order (no sort / filter in its address),
    // because more products may follow on pages she did not load.
    var defaultOrder = !/[?&](sort_by|filter\.)/.test(String(data.url || ''));
    // r11: Shopify's own "Previous" stays at the start of her list only when that list began on a later page
    // (?page=2 or more); this name was used below without being defined (a script error on those pages)
    var laterPage = /[?&]page=(?:[2-9]|\d{2,})/.test(String(data.url || ''));
    var clearLink = function (a) {
      if (!a) return false;
      // keeps its address (this product) while hidden: no empty links for search engines (r9 T7)
      if (!a.getAttribute('href')) a.setAttribute('href', window.location.pathname);
      a.removeAttribute('aria-label');
      a.hidden = true;
      return false;
    };
    var setLink = function (a, item, label, keepPage) {
      if (!a) return false;
      if (!item) return keepPage && !a.hidden && a.getAttribute('href') ? true : clearLink(a);
      var href = typeof item.url === 'string' && /^\/(?!\/)/.test(item.url) ? item.url : route('products/' + encodeURIComponent(item.handle));
      a.setAttribute('href', href);
      a.setAttribute('aria-label', tpl(label, { title: item.title || item.handle }));
      a.hidden = false;
      return true;
    };
    var hasPrev = setLink(nav.querySelector('[data-vt-pdp-prev]'), items[index - 1], nav.dataset.prevLabel, defaultOrder && !!coll && laterPage);
    var hasNext = setLink(nav.querySelector('[data-vt-pdp-next]'), items[index + 1], nav.dataset.nextLabel, defaultOrder && !!coll);
    var sep = nav.querySelector('.vt-pdp-nav__sep');
    if (sep) sep.hidden = !(hasPrev && hasNext);
    nav.hidden = !(hasPrev || hasNext);
  }

  /* ---- r9 U4: "Tap to zoom" once, on the first product she opens --------------------------------
     Decorative (aria-hidden): the photo link has its own label. Fades only with Theme settings > Enable
     animations and never for people who ask for less motion; goes away on her first tap / key / swipe. */
  var ZOOM_HINT_KEY = 'vt-zoom-hint-seen';
  function initZoomHint() {
    var hint = document.querySelector('.section-main-product [data-vt-zoom-hint]');
    if (!hint) return;
    if (core.storageGet('localStorage', ZOOM_HINT_KEY)) { hint.remove(); return; }
    var main = hint.closest('.main-image');
    if (!main || !main.querySelector('.show-gallery') || main.offsetParent === null) return;
    var fade = document.documentElement.classList.contains('vt-anim') && !core.reducedMotion();
    var events = ['pointerdown', 'keydown'];
    var state = 'waiting';
    var timer = null;
    var hide = function () {
      if (state === 'gone') return;
      var wasShown = state === 'shown';
      state = 'gone';
      window.clearTimeout(timer);
      events.forEach(function (e) { document.removeEventListener(e, hide, true); });
      if (!wasShown || !fade) { hint.hidden = true; return; }
      hint.classList.remove('is-in');
      window.setTimeout(function () { hint.hidden = true; }, 450);
    };
    var show = function () {
      if (state !== 'waiting') return;
      state = 'shown';
      core.storageSet('localStorage', ZOOM_HINT_KEY, '1');
      hint.hidden = false;
      if (fade) {
        void hint.offsetWidth; // start from opacity 0
        hint.classList.add('is-in');
      }
      timer = window.setTimeout(hide, 4000);
    };
    events.forEach(function (e) { document.addEventListener(e, hide, true); });
    window.setTimeout(show, 700);
  }

  /* ---- r9 T5: size / colour buttons say "sold out" to screen readers (Symmetry only greys them) ---- */
  function initOptionLabels() {
    var picker = document.querySelector('.section-main-product variant-picker');
    if (!picker || !S.soldOut) return;
    var run = function () {
      picker.querySelectorAll('input.opt-btn[type="radio"]').forEach(function (input) {
        var label = input.nextElementSibling;
        if (!label || label.tagName !== 'LABEL') return;
        var note = label.querySelector('.vt-sr-sold');
        var out = input.classList.contains('is-unavailable');
        if (out && !note) {
          note = document.createElement('span');
          note.className = 'visually-hidden vt-sr-sold';
          note.textContent = ', ' + S.soldOut;
          label.appendChild(note);
        } else if (!out && note) {
          note.remove();
        }
      });
    };
    var later = function () { window.setTimeout(run, 0); };
    picker.addEventListener('change', later);
    (picker.closest('.js-product') || document).addEventListener('on:variant:change', later);
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('variant-picker').then(later);
    later();
  }

  /* ---- r9 T5: information rows (Description / Product details / Delivery & payment / Refund policy) ----
     They are the browser's own <details>/<summary> (a button for keyboards and screen readers); aria-expanded is
     kept in step as well, for the screen readers that do not read the open / closed state of <summary>. */
  function initAccordionState() {
    document.querySelectorAll('.section-main-product .product-info-accordion details').forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      if (!summary) return;
      var sync = function () { summary.setAttribute('aria-expanded', details.open ? 'true' : 'false'); };
      sync();
      details.addEventListener('toggle', sync);
    });
  }

  /* ---- "More in Black Heels" follows the colour picked -------------------------------------------------
     Each link carries its colour (data-vt-mc="full black"); only the one for the picked colour shows. The row sits right after the colour fieldset (snippets/variant-picker.liquid). */
  function initMoreColour() {
    document.querySelectorAll('.vt-more-colour-row').forEach(function (row) {
      var fs = row.previousElementSibling;
      if (!fs) return;
      var sync = function () {
        var on = fs.querySelector('input:checked');
        var v = on ? String(on.value).toLowerCase() : '';
        row.querySelectorAll('[data-vt-mc]').forEach(function (a) { a.hidden = v.trim() !== a.getAttribute('data-vt-mc'); });
      };
      fs.addEventListener('change', sync);
      sync();
    });
  }


  /* ------------------------------------------------------------------ boot */

  /* "Order Now - Cash on Delivery" styling moved to assets/vt-theme.js (initOrderNowLook) — it shows on the bag page too. */

  core.onReady(function () {
    recordRecentlyViewed();
    initGalleryCounter();
    initDeliveryHint();
    initSizeMemory();
    initStickyOptions();
    // round 7
    initSimilarPrice();
    // round 9
    initPdpNav();
    initZoomHint();
    initOptionLabels();
    initAccordionState();
    // round 11
    initFade();
    initNextPhoto();
    initYourSize();
    initMoreColour();
  });
})();

/* 25 Sep 2026 — open on a colour that has its own photo (marker from snippets/vt-open-colour.liquid).
   Only when the address has no ?variant= (cards already link to the right colour). */
(function () {
  'use strict';
  function run() {
    if (/[?&]variant=/.test(location.search)) return;
    document.querySelectorAll('[data-vt-open-colour]').forEach(function (m) {
      var box = m.closest('.input-row') || document;
      var sets = box.querySelectorAll('.option-selector');
      var set = sets[parseInt(m.dataset.optionIndex, 10)];
      if (!set) return;
      var want = m.dataset.value;
      var input = Array.prototype.find.call(set.querySelectorAll('input.js-option[type="radio"]'), function (i) { return i.value === want; });
      if (input && !input.checked) input.click();
    });
  }
  // wait for the theme's variant picker to be ready, otherwise the click is not heard
  function start() {
    if (window.customElements && customElements.whenDefined) {
      Promise.race([customElements.whenDefined('variant-picker'), new Promise(function (r) { setTimeout(r, 3000); })])
        .then(function () { setTimeout(run, 0); });
    } else { run(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------------------------------------------------------------------------
   7 Oct 2026 (ads team, round 2: "size 36 is already selected when the page opens, so the order form shows
   'Black / 36' even if the customer never chose a size"): the size starts with nothing chosen
   (snippets/variant-picker.liquid, fieldset[data-vt-size-gate]). Until a size is tapped, ORDER NOW, the sticky bar's
   buttons and Add to cart do not go on: the page scrolls to the sizes and says "Choose your size".
   --------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.vtSizeGate) return;
  window.vtSizeGate = true;
  function gate() { return document.querySelector('.section-main-product fieldset[data-vt-size-gate]'); }
  if (!gate()) return;
  var ar = /^ar/i.test(document.documentElement.lang || '');
  var MSG = ar ? 'اختاري المقاس' : 'Choose your size';
  function chosen() {
    var g = gate();
    return !g || !!g.querySelector('input[type="radio"]:checked');
  }
  function ask() {
    var g = gate();
    if (!g) return;
    var note = g.querySelector('.vt-size-need__msg');
    if (!note) {
      note = document.createElement('p');
      note.className = 'vt-size-need__msg';
      note.setAttribute('role', 'alert');
      note.textContent = MSG;
      g.appendChild(note);
    }
    g.classList.remove('vt-size-need');
    void g.offsetWidth; // restart the little shake
    g.classList.add('vt-size-need');
    g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = g.querySelector('input[type="radio"]:not(:disabled)');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
  }
  // every way to order from this page
  var SEL = '.es-popup-button-product, [data-vt-sticky-order], .section-main-product button[name="add"], sticky-atc button[name="add"], .section-main-product .shopify-payment-button button';
  function stop(e) {
    if (chosen()) return;
    var t = e.target && e.target.closest && e.target.closest(SEL);
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ask();
  }
  ['pointerdown', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) { if (type === 'click') stop(e); else if (!chosen() && e.target.closest && e.target.closest(SEL)) { /* the click that follows is stopped */ } }, true);
  });
  document.addEventListener('submit', function (e) {
    if (chosen()) return;
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart/add"]') && (f.closest('.section-main-product') || f.closest('sticky-atc'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      ask();
    }
  }, true);
  document.addEventListener('change', function (e) {
    var g = gate();
    if (g && e.target && g.contains(e.target)) {
      g.classList.remove('vt-size-need', 'vt-size-unset');
      var note = g.querySelector('.vt-size-need__msg');
      if (note) note.remove();
    }
  });
})();

/* ---------------------------------------------------------------------------
   8 Oct 2026 (URGENT, ads team): a SOLD-OUT size could still be ordered — Add to cart said "Sold out", but ORDER NOW
   (EasySell), the sticky bar's "Order Now" and EasySell's own sticky button stayed on and opened the form.
   Now, once the chosen size / colour is sold out, all three are hidden (Add to cart beside them already says
   "Sold out"), a tap on any of them does nothing, and if the order form ever opens for a sold-out choice it closes
   at once. Picking an in-stock size brings them straight back. "Sold out" = the page's own Add to cart is switched
   off for the chosen size (the theme already does that from the live stock).
   --------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.vtSoldGuard) return;
  window.vtSoldGuard = true;
  if (!document.querySelector('.section-main-product')) return;
  var ORDER = '.es-popup-button-product, .es-sticky-product, [data-vt-sticky-order]';
  function addBtn() { return document.querySelector('.section-main-product button[name="add"]'); }
  function sizeChosen() {
    var g = document.querySelector('.section-main-product fieldset[data-vt-size-gate]');
    return !g || !!g.querySelector('input[type="radio"]:checked');
  }
  function soldOut() { var b = addBtn(); return !!(b && b.disabled && sizeChosen()); }
  function paint() { document.documentElement.classList.toggle('vt-chosen-soldout', soldOut()); }
  // taps: stopped before EasySell or the sticky bar sees them
  var fromProduct = false;
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest(ORDER);
    if (!t) return;
    fromProduct = true;
    if (!soldOut()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    paint();
  }, true);
  document.addEventListener('click', function (e) {
    // the bag's own Order Now opens the bag form, not this product's
    if (e.target && e.target.closest && e.target.closest('cart-drawer, .cart-drawer, .es-popup-button-cart, [data-vt-bag-order], .vt-bag-order')) fromProduct = false;
  }, true);
  // the order form opening for a sold-out choice (any other way in): close it straight away
  function watchModal(m) {
    if (!m || m.vtSoldWatch || !('MutationObserver' in window)) return;
    m.vtSoldWatch = true;
    new MutationObserver(function () {
      var d = m.style.display;
      if (d && d !== 'none' && fromProduct && soldOut()) {
        var x = m.querySelector('.close-icon, [class*="close"]');
        if (x) x.click(); else m.style.display = 'none';
      }
    }).observe(m, { attributes: true, attributeFilter: ['style'] });
  }
  watchModal(document.getElementById('easysell-modal'));
  if ('MutationObserver' in window) {
    var bodyMo = new MutationObserver(function () {
      var m = document.getElementById('easysell-modal');
      if (m) { watchModal(m); bodyMo.disconnect(); }
    });
    if (!document.getElementById('easysell-modal')) bodyMo.observe(document.body, { childList: true });
    // Add to cart switching on / off (size or colour changed)
    var form = document.querySelector('.section-main-product form[action*="/cart/add"]') || document.querySelector('.section-main-product');
    new MutationObserver(paint).observe(form, { attributes: true, attributeFilter: ['disabled'], subtree: true, childList: true });
  }
  document.addEventListener('change', function () { setTimeout(paint, 0); setTimeout(paint, 300); });
  document.addEventListener('on:variant:change', function () { setTimeout(paint, 0); });
  paint();
  setTimeout(paint, 800);
})();
